import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { IOrderedItemView } from "interfaces/session/ShoppingCart";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import PAImage from "../../../component/design-system/images/PAImage";
import Text, { TEXT_TYPE } from "../../../component/design-system/typography/Text";
import ProductDescription from "../../../component/product/ProductDescription";
import HideIf from "../../../util/HideIf";
import { getProductImage } from "../../../util/helper/getProductImage";
import styles from "./style.module.scss";
const ProductDescriptionFromStaticContent = dynamic(() => import(/* webpackChunkName: "product-description-static" */"modules/product/ProductDescriptionFromStaticContent"));

interface IKitComponents {
  product: IOrderedItemView;
  cols?: number[];
  showQuantity?: boolean;
  showTopBorder?: boolean;
  productQuantity?: number;
  showComponentDescription?: boolean;
}

const KitComponents = (props: IKitComponents) => {
  const { t } = useTranslation("shopping-cart");
  const {
    product, showQuantity, cols = [6, 2, 4], productQuantity, showTopBorder = false,
    showComponentDescription = false,
  } = props;

  const { components = [] } = product.extendedDescription || {};
  if (!components.length) {
    return null;
  }
  if (showQuantity && (!cols || cols.length !== 3)) {
    return null;
  }

  const itemsToInclude = (component: any) => (
    <div
      key={component.sku}
      className="row m-t-15 m-b-15 m-l-0 m-r-0"
    >

      <div className={`col-xs-${cols[0]} d-flex p-0 ${styles.kit_items}`}>

        <div className="m-r-20 m-b-10">
          <PAImage
            src={getProductImage(component.thumbnail)}
            width={60}
            height={60}
            alt={component.description}
          />

        </div>

        <div>

          <ProductDescription
            className={styles.productComponentDesc}
            {...{ item: component }}
          />
        </div>
      </div>

      <div className={`col-xs-${cols[1]} center-block text-center`}>

        <HideIf show={showQuantity}>
          <PAText fontSize={FONT_SIZE[0]}>
            {`${t("Quantity")}: `}
            {(component.quantity || 1) * (productQuantity || product.quantity)}
          </PAText>
        </HideIf>
      </div>

      <div className={`col-xs-${cols[2]}`} />
    </div>
  );
  return (
    <div className="row m-l-0 m-r-0">

      <div className={classNames("col-sm-12 p-l-0 p-r-0", {
        [styles.topBorder]: showTopBorder,
      })}
      >

        <Text size={5} type={TEXT_TYPE.secondary}>{t("Items Included")}</Text>
        {
          components.map((component: any) => (
            <>
              {itemsToInclude(component)}
              <HideIf show={showComponentDescription}>
                <ProductDescriptionFromStaticContent
                // isFeaturesAndBenefitsNodeExists={isFeaturesAndBenefitsNodeExists}
                  contentIds={component.pageContent?.links?.contentIds}
                  extendedDescription={product.extendedDescription}
                />
                <hr />
              </HideIf>
            </>
          ))
        }
      </div>
    </div>
  );
};

export default KitComponents;
